module.exports = __webpack_public_path__ + "static/media/IELTS-AcademicReading-TableMatch2.ff28fecd.png";